export default {
  add_popup: 'A\u00f1adir',
};
